// Reactive flags
export const NoneFlag = 0

export const MutableFlag = 1 << 0

export const WatchingFlag = 1 << 1

export const RecursedCheckFlag = 1 << 2

export const RecursedFlag = 1 << 3

export const DirtyFlag = 1 << 4

export const PendingFlag = 1 << 5

// Mode flags
export const ScopeMode = 1 << 0

export const LazyMode = 1 << 1

export const WritableMode = 1 << 2

export const MountableMode = 1 << 3

export const ExternalModesBase = 4
